<div class="modal-dialog modal-{{size}} modal-dialog-scrollable">
  <div class="modal-content">
    <div class="modal-header {{headerClass}}">
      <h4 class="modal-title">{{ title }}</h4>
      @if (isShowCloseButton) {
        <button type="button" class="close {{iconTextClass}}" aria-label="Close" (click)="dismiss()">
          <span aria-hidden="true"><app-icon name="times"></app-icon></span>
        </button>
      }
    </div>
    <div class="modal-body {{bodyClass}}">
      @switch (contentType) {
        @case ('string') {
          <div [innerHTML]="content"></div>
        }
        @case ('template') {
          <ng-container *ngTemplateOutlet="content; context: context"></ng-container>
        }
        @case ('component') {
          <ng-container *ngComponentOutlet="content"></ng-container>
        }
      }
    </div>
  </div>
</div>